import PageContainer from '@/common/components/PageContainer'
import CarouselListing from '@/modules/client-setting/components/Carousel/components/CarouselListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CarouselPage() {
	return (
		<PageContainer>
			<CarouselListing />
		</PageContainer>
	)
}

const GuardedCarouselPage = withUserPermission(CarouselPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedCarouselPage
